"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFirstMountState = void 0;
const react_1 = require("react");
/**
 * React hook to check if current render is first
 *
 * @param initialState the initial boolean state value
 */
function useFirstMountState() {
    const isFirst = (0, react_1.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
exports.useFirstMountState = useFirstMountState;
//# sourceMappingURL=use-first-mount-state.js.map